import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconUserRemoveRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUserRemoveRight"><Path d="M2.5 20.5V19.5C2.5 15.3579 5.85786 12 10 12C14.1421 12 17.5 15.3579 17.5 19.5V20.5H2.5Z" stroke="currentColor"/><Circle cx="10" cy="7.5" r="4.5" stroke="currentColor"/><Path d="M18.75 9.5L21 11.75M21 11.75L23.25 14M21 11.75L23.25 9.5M21 11.75L18.75 14" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconUserRemoveRight;
